<template>
  <div>
    <v-alert
      :type="type"
      transition="scale-transition"
      v-model="alert"
      border="left"
      dismissible
    ><pre class="body-1">{{msg}}</pre></v-alert>
  </div>
</template>


<script>
export default {
  props: {
    type: String,
    alertShow: Boolean,
    msg: String
  },
  data: () => ({
    alert: false,
  }),
  watch:{
    alertShow : function(value){
      this.alert = value;
    },
    alert: function(value){
      if(!value){
        this.$emit("closealert");
      }
    }
  }
};
</script>